import angular from 'angular';

import service from './dealerChat.service';
import User from 'cars-ng-user';
import config from '../app.config';
import Listing from '../listing';
import NgTracking from 'cars-ng-tracking';

export default angular.module('vdp.dealerChat', [
    User, Listing, NgTracking
])

.service('dealerChatService', service)

.name;
